<template>
    <div id="formulario-funcionario">
        <div id="formCampos">
            <div class="row">
                <div class="input-field col s12">
                    <input
                        placeholder="Nome"
                        id="categoria_nome"
                        type="text"
                        v-model="formData.categoria_nome"
                    />
                    <label
                        for="categoria_nome"
                        :class="checkValue(formData.categoria_nome)"
                        >Nome*</label
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.carregar-itens {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f7f7f7;
    cursor: pointer;
}
.carregar-itens:hover {
    background-color: #e6e6e6;
}
#formCampos.step-parent {
    padding: 10px;
}
</style>
<script>
import { DONO, GERENTE, ESPECIALISTA, MASTER } from "@/constants/funcionarioCargo.js";
import Auth from "@/store/auth";
export default {
    props: ["categoria"],
    data: () => ({
        formData: {
            categoria_nome: ""
        }
    }),
    created() {
        // verifica se pode acessar componente
        if (
            Auth.getCargoUsuario() !== MASTER &&
            [DONO, GERENTE, ESPECIALISTA].indexOf(Auth.getCargoUsuario()) === -1
        ) {
            this.$router.push("/sempermissao");
        }
        if (this.categoria) {
            this.formData.categoria_nome = this.categoria.categoria_nome;
        }
    },
    methods: {
        checkValue(value) {
            if (value !== "") {
                return "active";
            }
            return "";
        }
    },
    watch: {
        formData: {
            handler: function() {
                this.$emit("newdata", [this.formData.categoria_nome]);
            },
            deep: true
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/categorias/Formulario.vue